export default __webpack_public_path__ + "static/media/ico_pdf.c1aaa7e9.svg";